import { Button, Card, Image, Tag } from "antd";
import PreferredLanguagePopUp from "../PreferredLanguagePopUp";
import { useState } from "react";
import { PopUp } from "../../../../atoms/PopUp";

export default function PreferredLanguage() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const changePreferredPopup = {
    visibility: isModalOpen,
    content: <PreferredLanguagePopUp onClose={() => setIsModalOpen(false)} />,
    width: 640,
    onCancel: () => setIsModalOpen(false),
  };

  return (
    <Card className="langCard">
      <Button className="langButton" onClick={() => setIsModalOpen(true)}>
        <div className="langTop">
          <div className="langIcon">
            <Image
              src="/images/myProfile/lang_icon.svg"
              alt="lock"
              preview={false}
            />
          </div>
          <Tag
            className="mint_tag"
            style={{
              backgroundColor: "#00A07D",
              borderColor: "#00A07D",
              color: "#FFFFFF",
              padding: "2px 5.2px",
            }}
          >
            English
          </Tag>
        </div>
        <h3>Preferred language</h3>
        <p>Select your language, and LandScaling will be displayed in it.</p>
      </Button>
      <PopUp {...changePreferredPopup} />
    </Card>
  );
}
